import React from "react";
import { StyleSheet, View } from "react-native";
import Button from "src/common/components/button";
import Text from "src/common/components/text";
import { ImageMapper } from "src/common/assets/images";
import { Image } from "src/common/components/image";
import translate from "libs/locale";
import variables from "../assets/variables";
import { PopularItemResponse } from "../types/response/storeItems";

const CounterButton = ({
  item,
  stock,
  inCart,
  rootItem,
  solidAdd = false,
  available = true,
  squared = false,
  onDecrement,
  onIncrement,
}: {
  item: any;
  stock: number;
  inCart: boolean;
  available?: boolean;
  solidAdd?: boolean;
  squared?: boolean;
  rootItem?: PopularItemResponse;
  onDecrement: (item: any) => void;
  onIncrement: (item: any) => void;
}) => {
  if (!available || stock <= 0) {
    if (!squared) {
      return (
        <Text style={[styles.addText, { color: "#B2BEC3" }]}>
          {translate("outOfStock")}
        </Text>
      );
    }
    return (
      <Button
        solid={solidAdd}
        style={[styles.add, solidAdd && styles.solidAdd, styles.disabled]}
        disabled
      >
        <Text style={[styles.addText, styles.outOfStock]}>
          {translate("outOfStock")}
        </Text>
      </Button>
    );
  } else if (inCart || !rootItem) {
    return (
      <View style={styles.incDec}>
        <Button
          solid={false}
          style={styles.actionBtn}
          onPress={() => onDecrement(item)}
        >
          <Image source={ImageMapper.Decrement} style={styles.incDecImg} />
        </Button>
        <Text style={[styles.price, styles.quantity]}>{item.quantity}</Text>
        <Button
          solid={false}
          style={styles.actionBtn}
          disabled={item.quantity === item.stock}
          onPress={() => onIncrement(item)}
        >
          <Image
            source={ImageMapper.Increment}
            style={[
              styles.incDecImg,
              item.quantity === item.stock && styles.disabledButton,
            ]}
          />
        </Button>
        <Button
          solid={false}
          style={[styles.actionBtn, styles.delete]}
          onPress={() => onDecrement({ ...item, quantity: 1 })}
        >
          <Image source={ImageMapper.Delete} style={styles.incDecImg} />
        </Button>
      </View>
    );
  }
  return (
    <Button
      solid={solidAdd}
      style={[styles.add, solidAdd && styles.solidAdd]}
      onPress={() => onIncrement(rootItem)}
    >
      {!solidAdd ? (
        <Image source={ImageMapper.Add} style={styles.addIcon} />
      ) : (
        <Text style={styles.addText}>{translate("add").toUpperCase()}</Text>
      )}
    </Button>
  );
};

const styles = StyleSheet.create({
  disabled: {
    justifyContent: "center",
    alignItems: "center",
  },
  incDecImg: {
    height: 22,
    width: 22,
    padding: 5,
  },
  disabledButton: {
    opacity: 0.5,
  },
  actionBtn: {
    height: 32,
    width: 32,
    alignItems: "flex-start",
  },
  quantity: {
    color: "#B2BEC3",
    marginRight: 10,
    minWidth: 30,
    textAlign: "center",
  },
  incDec: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 7,
    height: 35,
  },
  price: {
    color: "#F9A26C",
    fontSize: 14,
    lineHeight: 16,
    fontFamily: "MontserratBold",
  },
  addText: {
    fontSize: 14,
    fontFamily: "MontserratBold",
    color: "#ffff",
    lineHeight: 16,
  },
  delete: {
    marginLeft: 20,
  },
  outOfStock: {
    color: "#ffff",
    fontSize: 13,
  },
  add: {
    height: 35,
    width: 35,
  },
  solidAdd: {
    width: "100%",
    minWidth: 50,
    borderRadius: 7,
    marginTop: 7,
    backgroundColor: variables.$brandColor,
    padding: 0,
    height: 35,
  },
  addIcon: {
    height: 16,
    width: 16,
  },
});

export default React.memo(CounterButton);
